import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_300: DocMigration = {
  maxSchemaVersion: "0.0.300",
  description: "Edge dimensions from static room layout to room.",
  apply(json: any): any {
    const roomEdgeBehaviors: { [id: string]: any } = {};
    let count = Object.keys(json.roomEdgeBehaviors).length;
    for (const roomId in json.staticRoomLayouts) {
      const staticRoomLayout = json.staticRoomLayouts[roomId];
      const edgeDimensionBehavior = staticRoomLayout?.edgeDimensionBehavior;
      if (!edgeDimensionBehavior?.length) {
        continue;
      }

      for (const edgeDimension of edgeDimensionBehavior) {
        const id = uid();
        roomEdgeBehaviors[id] = {
          ...edgeDimension,
          entityType: "EDGE_BEHAVIOR",
          edgeBehaviorType: "DIMENSION",
          sortIndex: count++,
          parentId: roomId,
          id,
        };
      }

      delete staticRoomLayout.edgeDimensionBehavior;
    }

    json.roomEdgeBehaviors = { ...json.roomEdgeBehaviors, ...roomEdgeBehaviors };
    return json;
  },
};

export default migration_0_0_300;
